<!--选择离职员工--->
<template>
    <div>
        <van-search class="search-button" v-model="searchStr" @search="onLoad" @clear="selClear" placeholder="请输入搜索关键词" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
        </van-search>
        <div v-if="employeesList.length > 0">
            <div class="list-box">
                <van-checkbox-group v-model="result" @change="handleCheck">
                    <div class="new_section_4 flex-col" v-for="item in employeesList" :key="item.date">
                        <span class="text_5 flex flex-y-center">{{ item.date }}离职</span>
                        <div style="background-color: #ffffff; padding-bottom: 1px" v-for="employerinfo in item.employeelist" :key="employerinfo.id">
                            <div class="section_5 flex-row">
                                <van-checkbox class="label_5" icon-size="18px" :name="employerinfo" />
                                <div class="image-wrapper_1 flex-col">
                                    <img class="image_1" referrerpolicy="no-referrer" :src="employerinfo.avatar" alt="" />
                                </div>
                                <div class="text-wrapper_2 flex-col justify-between">
                                    <span class="text_6">{{ employerinfo.name }}</span>
                                    <span class="text_7">{{ employerinfo.contactCount }}位顾客</span>
                                </div>
                            </div>
                            <div class="section_6 flex-col"></div>
                        </div>
                    </div>
                </van-checkbox-group>
            </div>
            <div class="bot-a flex flex-between " v-if="result.length > 0">
                <div class="bot-aa">
                    <img class="image_3" referrerpolicy="no-referrer" v-for="item in checkedEmployeesInfo.photolist" :key="item.id" :src="item.avatar" alt="" />
                </div>
                <van-button round class="save_btn" @click="toAllocated()">确定</van-button>
            </div>
        </div>
        <!-- <div v-else>

            <img class="label_6" referrerpolicy="no-referrer" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" />
        </div> -->
        <div v-else class="flex flex-col flex-y-center">
            <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" class="empty-icon" alt="" />
            <div class="empty-txt">暂无顾客～</div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";

    export default {
        name: "quitEmployeesList",
        checkedEmployeesList: String,
        data() {
            return {
                searchStr: "", // 搜索条件
                employeesList: [],  //离职员工信息
                loading: false,
                result: [],   //头像
                //选中离职人员信息
                checkedEmployeesInfo: { photolist: [] }
            };
        },
        mounted() {
            this.onLoad();
        },
        methods: {
            onLoad() {
                request({
                    url: `/workEmployee/getAllResEmp?mobile=${this.searchStr}`,
                    method: "get",
                })
                    .then((res) => {
                        this.employeesList = res.data;
                    })
                    .finally(() => {
                        this.loading = false;

                    });
            },

            selClear() {
                this.searchStr = ""
            },

            //check复选框
            handleCheck(val) {
                this.checkedEmployeesInfo = {
                    contactCount: 0,
                    groupCount: 0,
                    photolist: []
                }

                if (val.length) {
                    val.map(n => {
                        this.checkedEmployeesInfo.contactCount += n.contactCount ? Number.parseInt(n.contactCount) : 0
                        this.checkedEmployeesInfo.groupCount += n.groupCount ? n.groupCount : 0
                        this.checkedEmployeesInfo.photolist.push({ id: n.id, name: n.name, avatar: n.avatar })
                    })
                }

            },

            //跳转顾客详情页
            toAllocated() {
                this.$router.push({ name: "toAllocated", query: { checkedEmployeesList: JSON.stringify(this.checkedEmployeesInfo) } });
            },
        },
    };
</script>

<style scoped>
    .list-box {
        height: 80vh;
        overflow-y: auto;
    }

    .new_section_4 {
        /* height: 193px; */
        background-color: rgba(245, 246, 247, 1);
        width: 750px;
    }

    .text_5 {
        width: 96px;
        height: 33px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 24px;
        white-space: nowrap;
        line-height: 33px;
        text-align: left;
        margin: 35px 0 10px 10px;
    }

    .section_5 {
        /* margin-top: 1px; */
        height: 150px;
        /* margin: 30px 0 0 30px; */
        background-color: rgb(255 255 255);
    }

    .label_5 {
        width: 40px;
        height: 40px;
        margin-top: 50px;
        margin-left: 30px;
    }

    .image-wrapper_1 {
        z-index: 37;
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 30px;
        margin-top: 40px;
    }

    .image_1 {
        z-index: 38;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .text-wrapper_2 {
        width: 90px;
        height: 92px;
        margin-left: 30px;
        margin-top: 30px;
    }

    .text_6 {
        width: 90px;
        height: 42px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
    }

    .text_7 {
        width: 89px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 13px;
    }

    .label_6 {
        width: 32px;
        height: 32px;
        margin: 55px 0 0 384px;
    }

    .section_6 {
        width: 506px;
        height: 1px;
        background-color: rgba(215, 215, 215, 1);
        margin: 2px 0 0 214px;
    }

    .section_7 {
        width: 690px;
        height: 92px;
        margin: 30px 0 0 30px;
    }

    .label_7 {
        width: 32px;
        height: 32px;
        margin-top: 30px;
    }

    .image-wrapper_2 {
        z-index: 40;
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 30px;
    }

    .image_2 {
        z-index: 41;
        position: absolute;
        left: 0;
        top: 0;
        width: 70px;
        height: 70px;
    }

    .text-wrapper_3 {
        width: 235px;
        height: 92px;
        margin-left: 30px;
    }

    .text_8 {
        width: 90px;
        height: 42px;
        display: inline-block;
        color: rgba(53, 67, 76, 1);
        font-size: 30px;
        white-space: nowrap;
        line-height: 42px;
        text-align: left;
    }

    .text_9 {
        width: 235px;
        height: 37px;
        display: inline-block;
        color: rgba(160, 172, 181, 1);
        font-size: 26px;
        white-space: nowrap;
        line-height: 37px;
        text-align: left;
        margin-top: 13px;
    }

    .label_8 {
        width: 32px;
        height: 32px;
        margin: 30px 0 0 239px;
    }

    .section_8 {
        width: 506px;
        height: 1px;
        background-color: rgba(215, 215, 215, 1);
        margin: 31px 0 0 214px;
    }

    .bot-a {
        /* height: 162px; */
        position: absolute;
        bottom: 0px;
        border: 1px solid rgba(203, 203, 203, 1);
        background-color: rgba(245, 246, 247, 1);
        margin-top: 450px;
        width: 750px;
    }

    .bot-aa {
        width: 65%;
        height: 100px;
        display: flex;
        margin: 20px 10px 10px 10px;
        /* margin-top: 10px; */
        overflow-x: auto;
    }

    .group_11 {
        height: 162px;
        border: 1px solid rgba(203, 203, 203, 1);
        background-color: rgba(245, 246, 247, 1);
        margin-top: 450px;
        width: 750px;
    }

    .group_12 {
        width: 690px;
        height: 70px;
        margin: 30px 0 0 0px;
    }

    .image-wrapper_3 {
        z-index: 72;
        position: relative;
        width: 70px;
        height: 70px;
        border-radius: 10px;
        overflow: hidden;
    }

    .image_3 {
        width: 70px;
        height: 70px;
        margin-left: 20px;
    }

    .text-wrapper_4 {
        height: 66px;
        border-radius: 33px;
        background-color: rgba(51, 63, 72, 1);
        margin-top: 2px;
        width: 162px;
    }

    .text_10 {
        width: 66px;
        height: 45px;
        display: inline-block;
        color: rgba(255, 255, 255, 1);
        font-size: 32px;
        letter-spacing: 1px;
        white-space: nowrap;
        line-height: 45px;
        text-align: center;
        margin: 11px 0 0 0px;
    }

    .save_btn {
        width: 162px;
        height: 66px;
        background: #333f48;
        border-radius: 44px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
        margin-top: 20px;
        margin-right: 15px;
    }

    .empty-icon {
        width: 280px;
        height: 280px;
        margin-top: 179px;
    }

    .empty-txt {
        font-size: 30px;
        color: #a0acb5;
    }

    :deep(.van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-search) {
        /* background-color: #f5f6f7 !important; */
        padding: 30px 30px !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 20px !important;
        margin-right: 0 !important;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }

    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }
</style>
